import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import React from 'react';

const Gazi = () => {
    const docs1 = [
        {
            uri: require("../../../../../Icon/Gazi case study.pdf"),
            fileType: 'pdf',
            fileName: 'Gazxi DITF Project.pdf'

        },
    ];
    return (
        <div className='kavan-section'>
            <div className='kavan-head'></div>
            <div>
                <DocViewer documents={docs1} pluginRenderers={DocViewerRenderers} />
            </div>
        </div>
    );
};

export default Gazi;